import React, { useRef, useState, useEffect } from 'react'
import { Card, CardHeader, CardBody, Badge } from '@byscott-io/corebyscott'
import { withUserStore } from '../../contexts/UserStore'
import GoalsPanel from './Dashboard/GoalsPanel'
import ActivityFeedPanel from './Dashboard/ActivityFeedPanel'
import DailyJournalPanel from './Dashboard/DailyJournalPanel'

const Dashboard = ({ userStore }) => {
  const activityFeedRef = useRef()
  const [isReady, setIsReady] = useState(false)
  const dataReady = userStore.account && userStore.currentAccountsUser

  // Only set isReady to true once, never flip it back
  // Add a small delay to ensure all data is fully settled
  useEffect(() => {
    if (dataReady && !isReady) {
      const timer = setTimeout(() => {
        setIsReady(true)
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [dataReady, isReady])

  return (
    <div className="container-fluid" style={{ paddingBottom: '3rem', marginTop: '-0.5rem' }}>
      <div className="row">
        <div className="col-md-12">
          <DailyJournalPanel />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <ActivityFeedPanel ref={activityFeedRef} />
        </div>
        <div className="col-md-6">
          <div className="cbs-scope" style={{ margin: '8px' }}>
            <Card>
              <CardHeader className="bg-light">
                <div className="d-flex align-items-center">
                  <i className="fas fa-bullseye text-primary me-2"></i>
                  <h6 className="mb-0 fw-bold">My Goals</h6>
                  <Badge color="secondary" className="ms-2">{dataReady ? (userStore.account.goals?.filter(g => g.accountsUserId === userStore.currentAccountsUser?.id)?.length || 0) : 0}</Badge>
                </div>
              </CardHeader>
              <CardBody style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {isReady ? (
                  <GoalsPanel />
                ) : (
                  <div className="text-center p-4 text-muted">
                    <i className="fas fa-spinner fa-spin fa-2x mb-2"></i>
                    Loading...
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withUserStore(Dashboard)
